module.exports = __webpack_public_path__ + "static/media/logo.8a265232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/logo.png
// module id = 776
// module chunks = 1